export default __webpack_public_path__ + "static/media/Hood of the Exorcist.0ecaef2f.jpg";